import Vue, { shallowRef } from 'vue';

export default {
  state: {
    pipelines: {},
    pipeline: null,
    jobs: {},
    job: null,
    jobLog: null,
    pipelineStages: [],
    stageJobs: {},
    jobsCount: null,
    pipelineStageJobs: [],
    pipelineFailedJobs: [],
    pipelineArtifacts: [],
    jobArtifacts: [],
    pipelineNeeds: [],
    pipelineIsCreating: false,
    pipelineSchedules: {},
    pipelineCurrentSchedule: {},
    pipelineCurrentSheduleEdit: [],
    pipelineTemplatesList: [],
    pipelineConfugurationExistence: null,
    loaderVariablesCiCd: false, 
  },
  mutations: {
    setPipelines(state, payload) {
      state.pipelines = { ...payload };
    },
    setPipeline(state, payload) {
      state.pipeline = { ...payload };
    },
    setJobs(state, payload) {
      state.jobs = { ...payload };
    },
    setJob(state, payload) {
      state.job = { ...payload };
    },
    setJobLog(state, payload) {
      state.jobLog = shallowRef({ ...payload });
    },
    setPipelineStages(state, payload) {
      state.pipelineStages = [...payload];
    },
    setStageJobs(state, payload) {
      state.stageJobs = {};
      state.jobsCount = payload.length;
      payload.forEach((item) => {
        if (state.stageJobs[item.stage.id]) {
          Vue.set(state.stageJobs, item.stage.id, [...state.stageJobs[item.stage.id], item]);
        } else Vue.set(state.stageJobs, item.stage.id, [item]);
      });
    },
    setPipelineStageJobs(state, payload) {
      state.pipelineStageJobs = [...payload];
    },
    setPipelineFailedJobs(state, payload) {
      state.pipelineFailedJobs = [...payload];
    },
    setPipelineArtifacts(state, payload) {
      state.pipelineArtifacts = [...payload];
    },
    setJobArtifacts(state, payload) {
      state.jobArtifacts = [...payload];
    },
    setPipelineNeeds(state, payload) {
      state.pipelineNeeds = [...payload];
    },
    setPipelineIsCreating(state, payload) {
      state.pipelineIsCreating = payload;
    },
    deleteJobLog(state) {
      state.jobLog = null;
    },
    deleteArtifact(state, payload) {
      if (state.jobArtifacts && state.jobArtifacts.length > 0) {
        state.jobArtifacts = [...state.jobArtifacts.filter((item) => item.id !== payload)];
      }

      if (state.pipelineArtifacts && state.pipelineArtifacts.length > 0) {
        state.pipelineArtifacts = [
          ...state.pipelineArtifacts.filter((item) => item.id !== payload)
        ];
      }
    },
    setPipelineSchedules(state, payload) {
      state.pipelineSchedules = { ...payload };
    },
    deletePipelineSchedule(state, payload) {
      if (state.pipelineSchedules && state.pipelineSchedules.length > 0) {
        state.pipelinesSchedules = [
          ...state.pipelineSchedules.filter((item) => item.id !== payload)
        ];
      }
    },
    setPipelineCurrentSchedule(state, payload) {
      state.pipelineCurrentSchedule = { ...payload };
      state.pipelineCurrentSheduleEdit = payload?.existingVariables;
    },
    setPipelineTemplatesList(state, payload) {
      state.pipelineTemplatesList = payload;
    },
    setPipelineConfugurationExistence(state, payload) {
      state.pipelineConfugurationExistence = payload;
    },
    setVariablesLoaderCiCd(state, payload) {
      state.loaderVariablesCiCd = payload
    }
  },
  actions: {
    setPipelines(state, payload) {
      state.commit('setPipelines', payload);
    },
    setPipeline(state, payload) {
      state.commit('setPipeline', payload);
    },
    setJobs(state, payload) {
      state.commit('setJobs', payload);
    },
    setJob(state, payload) {
      state.commit('setJob', payload);
    },
    // добавляет в стейт shallowRef логов джоба
    setJobLog(state, payload) {
      state.commit('setJobLog', payload);
    },
    setPipelineStages(state, payload) {
      state.commit('setPipelineStages', payload);
    },
    setStageJobs(state, payload) {
      state.commit('setStageJobs', payload);
    },
    setPipelineStageJobs(state, payload) {
      state.commit('setPipelineStageJobs', payload);
    },
    setPipelineFailedJobs(state, payload) {
      state.commit('setPipelineFailedJobs', payload);
    },
    setPipelineArtifacts(state, payload) {
      state.commit('setPipelineArtifacts', payload);
    },
    setJobArtifacts(state, payload) {
      state.commit('setJobArtifacts', payload);
    },
    setPipelineNeeds(state, payload) {
      state.commit('setPipelineNeeds', payload);
    },
    setPipelineIsCreating(state, payload) {
      state.commit('setPipelineIsCreating', payload);
    },
    deleteJobLog(state) {
      state.commit('deleteJobLog');
    },
    deleteArtifact(state, payload) {
      state.commit('deleteArtifact', payload);
    },
    setPipelineSchedules(state, payload) {
      state.commit('setPipelineSchedules', payload);
    },
    deletePipelineSchedule(state, payload) {
      state.commit('deletePipelineSchedule', payload);
    },
    setPipelineCurrentSchedule(state, payload) {
      state.commit('setPipelineCurrentSchedule', payload);
    },
    setPipelineTemplatesList(state, payload) {
      state.commit('setPipelineTemplatesList', payload);
    },
    setPipelineConfugurationExistence(state, payload) {
      state.commit('setPipelineConfugurationExistence', payload);
    },
    setVariablesLoaderCiCd(state, payload) {
      state.commit('setVariablesLoaderCiCd', payload)
    }
  },
  getters: {
    getPipelines(state) {
      return state.pipelines;
    },
    getPipeline(state) {
      return state.pipeline;
    },
    getJobs(state) {
      return state.jobs;
    },
    getJob(state) {
      return state.job;
    },
    getJobLog(state) {
      return state.jobLog;
    },
    getPipelineStages(state) {
      return state.pipelineStages;
    },
    getPipelineStageJobs: (state) => (stageId) => state.stageJobs[stageId],
    getPipelineJobsCount(state) {
      return state.jobsCount;
    },
    getAllStagesWithJobs(state) {
      return state.stageJobs;
    },
    getPipelineStageJobsList(state) {
      return state.pipelineStageJobs;
    },
    getPipelineFailedJobs(state) {
      return state.pipelineFailedJobs;
    },
    getPipelineArtifacts(state) {
      return state.pipelineArtifacts;
    },
    getJobArtifacts(state) {
      return state.jobArtifacts;
    },
    getPipelineNeeds(state) {
      return state.pipelineNeeds;
    },
    getPipelineIsCreating(state) {
      return state.pipelineIsCreating;
    },
    getPipelinesSchedules(state) {
      return state.pipelineSchedules;
    },
    getCurrentPipelineSchedule(state) {
      return state.pipelineCurrentSchedule;
    },
    getCurrentSheduleEdit(state) {
      return state.pipelineCurrentSheduleEdit
    },
    getPipelineTemplatesList(state) {
      return state.pipelineTemplatesList;
    },
    getPipelineConfugurationExistence(state) {
      return state.pipelineConfugurationExistence;
    },
    getVariablesLoaderCiCd(state) {
      return state.loaderVariablesCiCd
    }
  }
};
